<template>
<div v-if="item">
    <BaseControlBar>
      <div class="flex-grow-1">
        <h1>優惠詳情</h1>
      </div>
    </BaseControlBar>
    <div class="container-fluid">
      <div class="coupon-form row">
        <div class="col-12 col-md-9">
          <div class="coupon-form__body">

            <div class="form-card">
              <b-container fluid>
                <!-- <h4>交易詳情</h4> -->
                <b-row class="row-style">
                  <b-col cols="4">
                    <label>商品編號</label>
                  </b-col>
                  <b-col style="color:mediumseagreen">
                    {{ item.id }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>優惠名稱</label>
                  </b-col>
                  <b-col>
                    {{ item.name1 }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>優惠使用期限</label>
                  </b-col>
                  <b-col>
                    {{ formatDateForQrCodePage(item.startDate, true) }}
                    至
                    {{ formatDateForQrCodePage(item.expire, true) }}
                  </b-col>
                </b-row>

                <b-row class="row-style" v-if="item.paymentType === 'HKD'">
                  <b-col cols="4">
                    <label>售價</label>
                  </b-col>
                  <b-col>
                    {{ formatCurrency(item.price) }}
                  </b-col>
                </b-row>

                <b-row class="row-style" v-if="item.paymentType === 'UFUN'">
                  <b-col cols="4">
                    <label>所需U Fun</label>
                  </b-col>
                  <b-col>
                    {{ item.cost }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>已兌換數量</label>
                  </b-col>
                  <b-col>
                    {{ item.totalUsedQuantity }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>總供應數量</label>
                  </b-col>
                  <b-col>
                    {{ item.quantity }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>優惠描述</label>
                  </b-col>
                  <b-col>
                    <div v-html="item.desc"></div>
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>適用分店地址/網址</label>
                  </b-col>
                  <b-col>
                    <div v-html="item.applicableAddressOrWebsite"></div>
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>使用條款及細則</label>
                  </b-col>
                  <b-col>
                    <div v-html="item.tnc"></div>
                  </b-col>
                </b-row>

                  <b-row class="row-style">
                  </b-row>
              </b-container>
            </div>

          </div>
        </div>
      </div>
    </div>

</div>
</template>

<script src="/js/DateFormat.js"></script>
<script>
import { mapState } from 'vuex';
import { scheduled, asyncScheduler } from 'rxjs';
import {
  tap, switchMap, debounceTime, pluck, mergeAll,
} from 'rxjs/operators';
import {
  BRow, BCol, BButton, BContainer,
} from 'bootstrap-vue';
import dataTableMixin from '../../mixins/data-table';
import http from '../../helpers/new-http';
import formatCurrency from '../../helpers/currency';
import { formatDateForQrCodePage } from '../../helpers/date';
import BaseControlBar from '../../components/BaseControlBar.vue';
import imagePath from '../../filters/image-path';

export default {
  mixins: [dataTableMixin],
  components: {
    BCol,
    BRow,
    BButton,
    BContainer,
    BaseControlBar,
  },
  data: () => ({
    loading: false,
    apiKey: 'no-api-key',
  }),
  methods: {
    formatCurrency,
    formatDateForQrCodePage,
  },
  computed: {
    ...mapState(['user']),
    id() {
      return this.$route.params.id;
    },
    rewardId() {
      return this.item.rewardId;
    },
    item() {
      return this.result?.reward;
    },
  },
  filters: {
    imagePath,
  },
  subscriptions() {
    const getData$ = () => http(
      {
        method: 'GET',
        url: `/agc-sub-merchant-api/qrcode/details/${this.id}?qrCode=true`,
      });

    return {
      result: scheduled(
        [...this.scheduleTasks],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        tap(() => {
          this.loading = true;
        }),
        debounceTime(250),
        pluck('data'),
        switchMap(getData$),
      ),
    };
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables';
// @import '@/assets/scss/transition/fade';
@import '@/assets/scss/mixin/modal/modal-history-status';
@import '../../assets/scss/coupon-form';

body {
  position: relative;
}

// remove space in the web view
.section-header{
  top: 0px;
}

.row-style{
  border-bottom: 1px solid #EBEEF0 !important;
  margin-left: 0;
  margin-right: 0;
  box-sizing: border-box;
  padding: 10px 5px 6px 0 !important;
  .col{
    padding: 0px 5px 6px 0}
}

.row-style-no-border{
  border-bottom: none !important;
}

.form-card {
  display: flex;
  flex-direction: column;
  .remark-style{
    border-bottom: 1px solid #EBEEF0 !important;
    margin-left: 0;
    margin-right: 0;
    box-sizing: border-box;
    padding: 10px 15px 6px 0 !important;
  }

  .photo{
    width: 50px;
    height: 50px;
  }

}
  ::v-deep{.form-control{
    background:#F9F9FA;
    font-size: 15px;
    padding: 0.375rem 0.75rem 0.375rem 0.5rem;
    color: #636d77;
    display: inline-block;
    width: 350px;
    position: relative;
    width: 100%;
  }
   .form-control:disabled{
    background:none;
    border:none;
    padding: 0.375rem 0.75rem 0.375rem 0.5rem;
  }

  .border-bottom{
    border-bottom:none !important;
  }

  .input-left{
    padding: 6px 0px 0px 15px !important;
  }
}

.coupon-stock-card {
  @include container;

  .title {
    @include title;
  }
}

.row-style div:first-child {
  padding-left: 0px;
}

// .coupon-form__body{
//   width: 100%;
// }

@media screen and (max-width: 650px) {
  .coupon-form{
    width: 100%;
  }

  .coupon-form .form-card{
    padding: 0px 0px;
  }

  .coupon-form__body{
    width: 100%;
  }

  .col-12.col-md-9{
    // remove padding in mobile view only
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .mobile{
    width: 150px;
  }

}
</style>
